// AboutPage.js
import React from 'react';

const AboutPage = () => {
  return (
    <div>
      <p>Hi, I'm Gillian. I'm a backend-focused developer who loves building tools that make other people's jobs easier. I specialize in internal tooling, automated workflows, and data pipelines that keep things running smoothly behind the scenes.</p>
      
      <p>I get excited about clean, reliable systems that just work. Whether it's streamlining a manual process or delivering data insights through pipelines, I enjoy solving the kinds of problems that often go unnoticed until something breaks.</p>
      
      <p>When I'm not debugging code or writing Airflow DAGs, I'm probably mapping out infrastructure ideas or finding new ways to automate the boring parts of work.</p>
    </div>
  );
};

export default AboutPage;